import React from 'react';
import { Box, Typography, Button, Card, CardContent, Grid, Avatar, Modal, Tooltip, IconButton, Dialog, DialogContent, DialogTitle } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import BackrrLogoImage from 'ui-components/BackrrLogoImage';
import { Primary, Secondary } from 'ui-components/Buttons';
import { FetchClaimProfileInvestorDetails } from 'api/profile';
import Cookies from 'js-cookie';
import { FetchAllInvestorTypes } from 'api/utils';
import ImageAvatar from 'ui-components/ImageAvatar';
import { checkForAuthorization, checkForDomain, getBucketUrl, navigateToMain } from 'utils/index';
import Wrapper from '../Wrapper';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTheme } from '@emotion/react';
import { RESET_STATE } from 'store/actions';
import { Logout } from '@mui/icons-material';
import PersonalDetails from './PersonalDetailsPopup';
import { ReactComponent as CloseIcon } from "assets/close_icon.svg"

const ClaimProfilePage = () => {
    // console.log("deded")
    const investor_id = Cookies.get('X-ADMIN-TEMP-ID') || Cookies.get('X-ADMIN-ID');
    const { data: investorData, isLoading: isLoadingInvestorData } = FetchClaimProfileInvestorDetails({
        investor_id
    });
    const { data: investor_types, isLoading: isLoadingInvestorTypes } = FetchAllInvestorTypes();
    const navigate = useNavigate();
    const theme = useTheme();
    const dispatch = useDispatch()
    const currentIP = window.location.host;
    const handleLogOut = () => {
        dispatch({ type: RESET_STATE });
        Cookies.remove('X-ADMIN-JWT', { path: '/' });
        Cookies.remove('X-ADMIN-JWT', { domain: checkForDomain() });
        Cookies.remove('X-ADMIN-ID', { path: '/' });
        Cookies.remove('X-ADMIN-ID', { domain: checkForDomain() });
        Cookies.remove('name', { path: '/' });
        Cookies.remove('user_id', { path: '/' });
        Cookies.remove('startup_id', { path: '/' });
        Cookies.remove('email', { path: '/' });
        Cookies.remove('is_profile_complete', { path: '/' });
        Cookies.remove('startup_id', { path: '/' });
        Cookies.remove('step', { path: '/' });
        Cookies.remove('permissions', { path: '/' });
        Cookies.remove('ur', { path: '/' });
        Cookies.remove('search_startups', { path: '/' });
        Cookies.remove('search_backrr_startups', { path: '/' });
        Cookies.remove('backrr_startups_query', { path: '/' });
        Cookies.remove('backrr_startups_status', { path: '/' });
        const cookies = document.cookie.split(";");
        cookies.forEach(cookie => {
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        });
        navigate('/login');
    };

    // console.log(investor_types,"investor_types")

    const isAngelInvestor = investorData?.data?.investor_type?.includes("angel");

    const profileData = {
        email: investorData?.data?.email,
        first_name: investorData?.data?.first_name,
        last_name: investorData?.data?.last_name,
        full_name: investorData?.data?.first_name + " " + investorData?.data?.last_name,
        name: isAngelInvestor ? investorData?.data?.first_name + " " + investorData?.data?.last_name : typeof investorData?.data?.organization_name === "string" ? investorData?.data?.organization_name : null,
        investor_type: investor_types?.find(type => type?.value === investorData?.data?.investor_type)?.label,
        image: getBucketUrl() + investorData?.data?.media_dir + "/" + (isAngelInvestor ? investorData?.data?.profile_logo?.custom_upload_url : investorData?.data?.profile_logo?.website_logo_url),
        website: typeof investorData?.data?.organization_website === "string" ? String(investorData?.data?.organization_website)?.toLowerCase()?.replaceAll("https://", "") : null,
        location: investorData?.data?.city?.name + ", " + investorData?.data?.country?.name
    }

    const [openModal, setOpenModal] = React.useState(false);

    const handleOpen = () => {
        setOpenModal(true);
    }
    const handleClose = () => {
        setOpenModal(false);
    }

    if (isLoadingInvestorTypes || isLoadingInvestorData) {
        return <Modal open={isLoadingInvestorTypes || isLoadingInvestorData}>
            <Wrapper className="skeleton" style={{
                display: 'grid', height: '100dvh',
                width: "100vw",
                placeItems: 'center'
            }}>
                {/* <CircularProgress sx={{ color: theme?.palette.customColors.b300 }} /> */}
            </Wrapper>
        </Modal>
    }

    // console.log(investorData?.data?.investor_type?.includes("angel"),"investorData")

    return (
        // isLoadingInvestorTypes || isLoadingInvestorData ?
        //  :
        <>
            <Grid item xs={12} display={"flex"} flexDirection={"column"} maxHeight={"736px"} gap={0}>
                <BackrrLogoImage onClick={(e) => {
                    navigateToMain(null)
                }} />
                <Typography variant='title' sx={{ fontSize: { xs: "1.5rem", md: "1.75rem" } }} marginTop={1} textAlign={{ xs: "center", md: 'start' }}>
                    Investor Profile Found
                </Typography>
                <Typography variant='bodyTextRegular' color={theme => theme.palette.customColors.g100} marginTop={1} sx={{ textAlign: { xs: 'center', md: "start" } }}>
                    We found an existing investor profile that matches your domain. You can either activate this profile or create a new one.
                </Typography>
                {/* Header */}
                {/* <Box sx={{ display: 'grid', alignItems: 'center', mb: 4, gap: 2 }}>
                <BackrrLogoImage sx={{
                    width: "3rem", height: "3rem"
                }} />
                <Typography variant="h6" fontWeight="bold">
                    Backrr for Admin
                </Typography>
            </Box> */}

                {/* Profile Found Section */}
                {/* <Box sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
                <Box
                    component="div"
                    sx={{
                        backgroundColor: '#f5f5f5',
                        width: 32,
                        height: 32,
                        borderRadius: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mr: 2
                    }}
                >
                    <Box component="span" sx={{ fontSize: '1.2rem' }}>📋</Box>
                </Box>
                <Typography variant="h6">
                    Investor Profile Found
                </Typography>
            </Box> */}

                {/* <Typography variant="body1" sx={{ mb: 4 }}>
                We found an existing investor profile that matches your information. You can either claim this profile or create a new one.
            </Typography> */}

                {/* Profile Card */}
                {/* {console.log(profileData?.image, "profileData?.image")} */}
                <Card variant="outlined" sx={{ marginY: 4, borderRadius: '8px' }}>
                    <CardContent sx={{ p: 3 }}>
                        <Grid container spacing={1}>
                            <Grid item container gap={2}>
                                <ImageAvatar src={profileData?.image} alt={profileData?.name} />
                                <Box>
                                    <Typography variant="h6" fontWeight="bold">
                                        {/* Acme Venture Capital */}
                                        {profileData?.name}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                        {profileData?.investor_type}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12}>

                                <Grid container columnSpacing={4} rowSpacing={2}>
                                    <Grid item xs={6}>
                                        <Typography fontSize={"0.8rem"} color="text.secondary" fontWeight={700} >
                                            Name
                                        </Typography>
                                        <Typography variant="body2" sx={{
                                            textWrapMode: 'nowrap',
                                        }}>
                                            {profileData?.full_name}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography fontSize={"0.8rem"} color="text.secondary" fontWeight={700} >
                                            Email
                                        </Typography>
                                        <Typography variant="body2" sx={{
                                            textWrapMode: 'nowrap',
                                        }}>
                                            {profileData?.email}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography fontSize={"0.8rem"} color="text.secondary" fontWeight={700}>
                                            Website
                                        </Typography>
                                        <Typography variant="body2" sx={{
                                            textDecoration: profileData?.website ? 'underline' : 'none',
                                            width: "min-content",
                                            textWrapMode: 'nowrap',
                                            // textUnderlineOffset: "4px",
                                            cursor: 'pointer',
                                            ":hover": {
                                                color: profileData?.website ? theme => theme.palette.customColors.indigo700 : "",
                                            }
                                        }} onClick={() => {
                                            window.open("https://" + profileData?.website, "_blank");
                                        }}>
                                            {profileData?.website ?? "-"}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography fontSize={"0.8rem"} color="text.secondary" fontWeight={700} >
                                            Location
                                        </Typography>
                                        <Typography variant="body2" sx={{
                                            textWrapMode: 'nowrap',
                                        }}>
                                            {profileData?.location}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>

                <Box sx={{

                    display: 'flex',
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 2
                }}>


                    <Secondary
                        // variant="outlined"
                        // fullWidth
                        sx={{
                            padding: '16px 16px',
                            fontWeight: 600,
                            minWidth: '64px',
                            flex: 1,

                            borderWidth: '1px',
                            height: '56.5px',
                            borderColor: theme => theme.palette.customColors.b300
                            // '& > .MuiButton-icon.MuiButton-startIcon': {
                            //     marginRight: isSmallScreen ? 0 : '8px',
                            //     marginLeft: isSmallScreen ? 0 : '-4px'
                            // }
                        }}
                    >
                        Create New Profile
                    </Secondary>

                    <Primary
                        // variant="contained"
                        // fullWidth
                        sx={{
                            padding: '16px 16px',
                            fontWeight: 600,
                            minWidth: '64px',
                            flex: 1,
                            height: '56.5px',
                            // '& > .MuiButton-icon.MuiButton-startIcon': {
                            //     marginRight: isSmallScreen ? 0 : '8px',
                            //     // marginLeft: isSmallScreen ? 0 : '-4px'
                            // }
                        }}
                        onClick={() => {
                            // navigate("/activate-profile")
                            handleOpen()
                        }}
                    >
                        Activate This Profile
                    </Primary>
                </Box>
                {/* Action Buttons */}

            </Grid>

            {checkForAuthorization() && <Tooltip title="Logout">
                <IconButton sx={{ position: 'absolute', top: 5, right: 10 }} onClick={() => { handleLogOut() }}>
                    <Logout />
                </IconButton>
            </Tooltip>}
            <Dialog open={openModal} onClose={() => {
                handleClose()
            }} sx={{
                "& > .MuiDialog-container > .MuiPaper-root": {
                    maxWidth: "500px",
                    borderRadius: "8px",
                }
            }}>
                <DialogTitle>
                    <IconButton
                        sx={{ position: "absolute", top: 10, right: 15, padding: 0 }}
                    >
                        <CloseIcon width={40} height={40} onClick={handleClose} />
                    </IconButton>
                    <Typography
                        sx={{
                            fontSize: "1.5rem",
                            fontWeight: 700,
                            lineHeight: "28px",
                            color: theme.palette.customColors.g300,
                            paddingLeft: "0.5rem",
                            textAlign: 'center',
                            marginTop: "0.5rem"
                        }}
                    >
                        Activate Profile
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <PersonalDetails investor_type={investorData?.data?.investor_type} handleClose={handleClose} />
                </DialogContent>
            </Dialog>
        </>
    );
};

export default ClaimProfilePage;